import { put } from "@redux-saga/core/effects";
import { LogApi } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import { setActionTypes } from "../../reducers/actionTypeReducer";

function setUpClient() {
  return new LogApi(getAPIConfig(store.getState().settings.internalSettings));
}

export function* handleGetActionTypes(): any {
  try {
    const logClient = setUpClient();
    const response = yield logClient.getAllActions();
    yield put(setActionTypes(response));
  } catch (error) {
    yield handleError(error);
  }
}
